import {Layout} from '~/components/layout'
import {Spinner} from '../spinner'
import './index.less'
import utils from '@eitje/utils'
import {useSpinnerVisibility} from '../hooks'

export const SpinnerWithBackdrop = ({backdropColor = 'white', delay = 0, isSpinning = true, isNested, size = 'medium'}) => {
	const isVisible = useSpinnerVisibility({delay, isSpinning})

	if (!isVisible) return null

	return (
		<Layout
			className={utils.makeCns(
				'spinner-with-backdrop',
				backdropColor === 'blue' && 'spinner-with-backdrop-blue',
				isNested && 'spinner-with-backdrop-nested',
			)}
		>
			<Spinner size={size} />
		</Layout>
	)
}
